import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconLike = _resolveComponent("IconLike")
  const _component_Feedback = _resolveComponent("Feedback")
  const _component_IconDislike = _resolveComponent("IconDislike")
  const _component_IconFav = _resolveComponent("IconFav")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pulse-actions", {show: $options.c_show}])
  }, [
    _createCommentVNode(" LIKE "),
    _createVNode(_component_Feedback, {
      "show-popover": !$options.liked,
      "fb-id": "like",
      teleported: $props.teleported,
      onSend: $options.onLike,
      onShow: _cache[0] || (_cache[0] = $event => (_ctx.$emit('show', $event)))
    }, {
      default: _withCtx(({visible}) => [
        _createElementVNode("div", {
          class: _normalizeClass(["action-btn", {visible}])
        }, [
          _createVNode(_component_IconLike, {
            size: $props.size,
            liked: $options.liked
          }, null, 8 /* PROPS */, ["size", "liked"])
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show-popover", "teleported", "onSend"]),
    _createCommentVNode(" DISLIKE "),
    _createVNode(_component_Feedback, {
      "show-popover": !$options.disliked,
      "fb-id": "dislike",
      teleported: $props.teleported,
      onSend: $options.onDislike,
      onShow: _cache[1] || (_cache[1] = $event => (_ctx.$emit('show', $event)))
    }, {
      default: _withCtx(({visible}) => [
        _createElementVNode("div", {
          class: _normalizeClass(["action-btn", {visible}])
        }, [
          _createVNode(_component_IconDislike, {
            size: $props.size,
            disliked: $options.disliked
          }, null, 8 /* PROPS */, ["size", "disliked"])
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show-popover", "teleported", "onSend"]),
    _createCommentVNode(" FAVORITE "),
    _createElementVNode("div", {
      class: "action-btn",
      onClick: _cache[2] || (_cache[2] = $event => ($options.favorite = !$options.favorite))
    }, [
      _createVNode(_component_IconFav, {
        size: $props.size,
        favorite: $options.favorite
      }, null, 8 /* PROPS */, ["size", "favorite"])
    ]),
    _createCommentVNode(" div class=\"action-btn\" disabled>\n      <IconAsButton :size=\"size\" icon=\"share-01\"/>\n    </div")
  ], 2 /* CLASS */))
}